/**
* 告警邮箱页筛选条件组件
*
* @author By AICode
* @date 2026-03-18
*/
<template>
  <div class="alert_email_form">
    <div class="search_box">
      <a-range-picker
        :value="dateRangeValue"
        format="YYYY-MM-DD HH:mm"
        :placeholder="['开始日期', '结束日期']"
        @change="handleDateRangeChange"
        :getCalendarContainer="getCalendarContainer()"
        :disabledDate="disabledDate"
      />
      <a-input-search
        v-model.trim="keyword"
        placeholder="请输入关键字"
        allow-clear
        @search="handleSearch"
      />
    </div>
    <a-space>
      <a-button class="btn_create" @click="$emit('create')" type="primary">新建</a-button>
      
      <a-popconfirm
        :title="`确认删除选中的 ${selectedCount} 条记录吗？`"
        ok-text="确认"
        cancel-text="取消"
        :disabled="selectedCount === 0"
        @confirm="$emit('delete')"
      >
        <a-button class="btn_delete" type="primary" :disabled="selectedCount === 0">删除</a-button>
      </a-popconfirm>
      <a-upload
        :accept="excelAccept"
        :show-upload-list="false"
        :before-upload="beforeUpload"
      >
        <a-button class="btn_import" type="primary">导入</a-button>
      </a-upload>
      <a-button class="btn_export" @click="$emit('export')" type="primary">导出</a-button>
    </a-space>
  </div>
</template>

<script>
import { Button, Space, Upload, Popconfirm, Input, DatePicker, message } from 'ant-design-vue'
import moment from 'moment'
import './filterCondition.less'

export default {
  name: 'AlertEmailFilterCondition',
  components: {
    'a-button': Button,
    'a-space': Space,
    'a-upload': Upload,
    'a-popconfirm': Popconfirm,
    'a-input-search': Input.Search,
    'a-range-picker': DatePicker.RangePicker,
  },
  props: {
    selectedCount: { type: Number, default: 0 },
    searchText: { type: String, default: '' },
    starTime: { type: String, default: '' },
    endTime: { type: String, default: '' },
  },
  data() {
    return {
      keyword: '',
      dateRangeValue: [],
      excelAccept: '.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      excelMaxSizeMb: 5,
    }
  },
  watch: {
    searchText: {
      immediate: true,
      handler(val) {
        this.keyword = val || ''
      },
    },
    starTime: {
      immediate: true,
      handler() {
        this.syncDateRangeValue()
      },
    },
    endTime: {
      immediate: true,
      handler() {
        this.syncDateRangeValue()
      },
    },
  },
  methods: {
    // 禁用 2001 年以前及今天之后的日期 - By AICode
    disabledDate(current) {
      return current < moment('2001') || current > moment().endOf('day')
    },
    getCalendarContainer() {
      return triggerNode => triggerNode.parentNode
    },
    syncDateRangeValue() {
      if (this.starTime && this.endTime) {
        this.dateRangeValue = [moment(this.starTime, 'YYYY-MM-DD HH:mm'), moment(this.endTime, 'YYYY-MM-DD HH:mm')]
        return
      }
      this.dateRangeValue = []
    },
    handleDateRangeChange(_, dateStrings) {
      const [starTime = '', endTime = ''] = dateStrings || []
      this.$emit('filter-change', {
        searchText: this.keyword.trim(),
        starTime,
        endTime,
      })
    },
    handleSearch() {
      this.$emit('filter-change', {
        searchText: this.keyword.trim(),
        starTime: this.starTime,
        endTime: this.endTime,
      })
    },
    beforeUpload(file) {
      const excelTypes = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ]
      const isExcel = excelTypes.includes(file.type) || /\.(xls|xlsx)$/i.test(file.name)
      if (!isExcel) {
        message.error('只支持导入 Excel 文件（.xls / .xlsx）')
        return false
      }
      const withinSizeLimit = file.size / 1024 / 1024 <= this.excelMaxSizeMb
      if (!withinSizeLimit) {
        message.error(`文件大小不能超过 ${this.excelMaxSizeMb}MB`)
        return false
      }
      this.$emit('import', file)
      return false
    },
  },
}
</script>
